import { render, staticRenderFns } from "./index-statistics.vue?vue&type=template&id=1e34937d&scoped=true"
import script from "./index-statistics.vue?vue&type=script&lang=js"
export * from "./index-statistics.vue?vue&type=script&lang=js"
import style0 from "./index-statistics.vue?vue&type=style&index=0&id=1e34937d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e34937d",
  null
  
)

export default component.exports